(() => {
  let scheduled = false;
  const text = {
    now: 'СЕГА',
    market: 'Пазарна цена',
    sort: 'Сортиране',
    recommended: 'Препоръчано',
    newest: 'Най-нови',
    lowHigh: 'Цена: ниска към висока',
    highLow: 'Цена: висока към ниска',
    best: 'Най-продавани'
  };
  const productAreaSelectors = [
    '.cloud-search-filters-products',
    '.template-search #product-grid',
    '.template-search .product-grid',
    '#cloud_search_filters_root .product-grid',
    '#cloud-search-products'
  ];
  const withinProductAreas = (selector) => productAreaSelectors
    .map((area) => `${area} ${selector}`)
    .join(',');

  if (/\/(?:a\/)?search(?:\/|$)/i.test(location.pathname)) {
    document.documentElement.classList.add('sxt-search-page');
  }

  const moneyValue = (value) => {
    const source = String(value || '').replace(/\u00a0/g, ' ');
    const match = source.match(/([0-9][0-9\s.,]*)\s*(?:€|EUR)/i);
    if (!match) return 0;
    let number = match[1].replace(/\s/g, '');

    if (number.includes(',')) {
      number = number.replace(/\./g, '').replace(',', '.');
    } else if ((number.match(/\./g) || []).length > 1 || /\.\d{3}$/.test(number)) {
      number = number.replace(/\./g, '');
    }
    return Number.parseFloat(number) || 0;
  };

  const center = (element) => {
    if (!element) return;
    element.style.setProperty('width', '100%', 'important');
    element.style.setProperty('max-width', 'none', 'important');
    element.style.setProperty('margin-inline', 'auto', 'important');
    element.style.setProperty('text-align', 'center', 'important');
  };

  const normalizeCloudBlocks = () => {
    document.querySelectorAll(withinProductAreas('.cs-price-block')).forEach((block) => {
      if (block.closest('.details-top-text')) return;
      if (block.dataset.sxtV25 === 'true' && block.querySelector('.sxt-price-now')) {
        center(block);
        return;
      }

      const prices = [...block.querySelectorAll('.price')];
      const currentNode = block.querySelector('.cs-has-list-price')
        || prices.find((node) => !node.classList.contains('cs-list-price'));
      const compareNode = block.querySelector('.cs-list-price');
      if (!currentNode) return;

      const current = currentNode.textContent.trim();
      const compare = compareNode?.textContent.trim() || '';
      const currentValue = moneyValue(current);
      const compareValue = moneyValue(compare);
      const discount = compareValue > currentValue && compareValue > 0
        ? Math.round(((compareValue - currentValue) / compareValue) * 100)
        : 0;

      block.dataset.sxtV25 = 'true';
      block.dataset.sxtV22 = 'true';
      block.dataset.sxtV7 = 'true';
      block.dataset.sxtDiscount = String(discount);
      block.dataset.sxtPrice = String(currentValue);
      block.classList.add('sxt-price-grid');
      block.classList.toggle('sxt-price-grid--sale', discount > 0);
      block.innerHTML = `<div class="sxt-price-now">${discount >= 50 ? `<span class="sxt-price-now__label">${text.now}</span>` : ''}<span class="sxt-current-grid"></span></div>${compare ? `<div class="sxt-price-reference">${text.market} <s></s>${discount ? ` <strong>(-${discount}%)</strong>` : ''}</div>` : ''}`;
      block.querySelector('.sxt-current-grid').textContent = current;
      const market = block.querySelector('.sxt-price-reference s');
      if (market) market.textContent = compare;

      center(block);
      center(block.closest('.card-information, .card-information__wrapper, [class*="product-info"], [class*="product-details"], [class*="product-card"]'));
    });
  };

  const normalizeThemeBlocks = () => {
    document.querySelectorAll(withinProductAreas('.sxt-price-grid')).forEach((grid) => {
      if (grid.dataset.sxtV25 === 'true' && grid.querySelector('.sxt-price-now')) {
        center(grid);
        return;
      }
      if (grid.querySelector('.sxt-price-now')) {
        grid.dataset.sxtV25 = 'true';
        grid.dataset.sxtV22 = 'true';
        grid.dataset.sxtV7 = 'true';
        center(grid);
        center(grid.closest('.card-information, .card-information__wrapper, [class*="product-info"], [class*="product-details"], [class*="product-card"]'));
        return;
      }
      const discountNode = grid.querySelector('.sxt-discount-grid');
      const compareNode = grid.querySelector('.sxt-compare-grid');
      const currentNode = grid.querySelector('.sxt-current-grid');
      if (!currentNode) return;

      const discount = Math.abs(Number.parseInt(discountNode?.textContent || '0', 10)) || 0;
      const current = currentNode.textContent.trim();
      const compare = compareNode?.textContent.trim() || '';

      grid.dataset.sxtV25 = 'true';
      grid.dataset.sxtV22 = 'true';
      grid.dataset.sxtV7 = 'true';
      grid.dataset.sxtDiscount = String(discount);
      grid.dataset.sxtPrice = String(moneyValue(current));
      grid.classList.toggle('sxt-price-grid--sale', discount > 0);
      grid.innerHTML = `<div class="sxt-price-now">${discount >= 50 ? `<span class="sxt-price-now__label">${text.now}</span>` : ''}<span class="sxt-current-grid"></span></div>${compare ? `<div class="sxt-price-reference">${text.market} <s></s>${discount ? ` <strong>(-${discount}%)</strong>` : ''}</div>` : ''}`;
      grid.querySelector('.sxt-current-grid').textContent = current;
      const market = grid.querySelector('.sxt-price-reference s');
      if (market) market.textContent = compare;
      center(grid);
      center(grid.closest('.card-information, .card-information__wrapper, [class*="product-info"], [class*="product-details"], [class*="product-card"]'));
    });
  };

  const ensureSort = () => {
    const productContainer = document.querySelector('.cloud-search-filters-products .product-grid-container');
    const mobileFilterRail = document.querySelector(
      '#cloud_search_filters_root .cloud-search-page-controls__filters'
    );
    const useMobileRail = window.matchMedia('(max-width: 749px)').matches && mobileFilterRail;
    const target = useMobileRail ? mobileFilterRail : productContainer;
    if (!productContainer || !target) return;

    const params = new URLSearchParams(location.search);
    const selected = params.get('sort_by') || 'manual';
    let bar = document.querySelector('.sxt-app-sortbar');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'sxt-app-sortbar';
      bar.innerHTML = `<label for="SxtAppSort">${text.sort}</label><select id="SxtAppSort" aria-label="${text.sort}"><option value="manual">${text.recommended}</option><option value="created-descending">${text.newest}</option><option value="price-ascending">${text.lowHigh}</option><option value="price-descending">${text.highLow}</option><option value="best-selling">${text.best}</option></select>`;

      const select = bar.querySelector('select');
      select.addEventListener('change', () => {
        const next = new URL(location.href);
        if (select.value === 'manual') next.searchParams.delete('sort_by');
        else next.searchParams.set('sort_by', select.value);
        location.assign(next.toString());
      });
    }

    const select = bar.querySelector('select');
    if ([...select.options].some((option) => option.value === selected)) select.value = selected;
    bar.classList.toggle('sxt-app-sortbar--chip', Boolean(useMobileRail));
    if (bar.parentElement !== target) target.prepend(bar);
  };

  const prepareMobileFilters = () => {
    const controls = document.querySelector(
      '#cloud_search_filters_root .cloud-search-page-controls__filters'
    );
    if (!controls) return;

    const kinds = [
      ['price', /^(цена|price)$/i],
      ['size', /^(размер|size)$/i],
      ['color', /^(цвят|цвятове|color|colour)$/i],
      ['brand', /^(марка|brand)$/i],
      ['type', /^(тип|type)$/i],
      ['gender', /^(пол|gender)$/i],
      ['discount', /^(намаление|discount)$/i],
      ['model', /^(модел|model)$/i]
    ];

    controls.querySelectorAll('.cloud-search-filter').forEach((filter) => {
      const name = String(filter.dataset.filterName || '').trim();
      filter.classList.toggle('sxt-filter-search-control', /^(потърси|search)/i.test(name));
      filter.setAttribute('aria-label', name);
      kinds.forEach(([kind, pattern]) => {
        filter.classList.toggle(`sxt-filter--${kind}`, pattern.test(name));
      });
    });
  };

  const enhance = () => {
    scheduled = false;
    normalizeCloudBlocks();
    normalizeThemeBlocks();
    prepareMobileFilters();
    ensureSort();
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(enhance);
  };

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });
  document.addEventListener('cloud-search:render', schedule);
  document.addEventListener('DOMContentLoaded', schedule, { once: true });
  window.addEventListener('popstate', schedule);
  window.addEventListener('resize', schedule);
  schedule();
})();
